class SocialFeedImages extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.slider = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      grabCursor: true,
      spaceBetween: 16,
      breakpoints: {
        990: {
          spaceBetween: 24,
          slidesPerView: 'auto',
        },
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      loop: true,
    });
  }
}

customElements.define('social-feed-images', SocialFeedImages);
